import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IndustriesResponse } from './types';
import { getIndustries, getSubIndustries } from './api';

export function useGetIndustries(options?: UseQueryOptions<IndustriesResponse[], Error>) {
  return useQuery<IndustriesResponse[]>({
    queryKey: ['industries'],
    queryFn: () => getIndustries(),
    ...options
  });
}

export function useGetSubIndustries(id: string | number, options?: UseQueryOptions<any[], Error>) {
  return useQuery<IndustriesResponse[]>({
    queryKey: ['sub_industries', id],
    queryFn: () => getSubIndustries(id),
    enabled: Boolean(id),
    ...options
  });
}
